import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import styled from "styled-components";
import xBtn from "../../image/x.png";
import axios from "axios";
import { useRecoilValue } from "recoil";
import { accessTokenAtom } from "../../recoil/auth";
import SaveAlert from "../Alert/SaveAlert";
import { BASE_URL } from "../../constants";
import { useTranslation } from "react-i18next";

async function patchPassword(data, accessToken) {
  const response = await axios.patch(
    `${BASE_URL}/user/profile`,
    {
      password: data.newPassword,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
}

export default function PasswordChangeModal({ isOpen, isClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const accessToken = useRecoilValue(accessTokenAtom);
  useEffect(() => {
    if (isOpen === true) {
      setModalIsOpen(true);
    }
  }, [isOpen]);

  function closeModal() {
    setModalIsOpen(false);
    isClose(false);
  }

  const onVaild = async (data) => {
    if (data.newPassword !== data.newPasswordConfirm) {
      setError(
        "newPassword",
        {
          message: "* 비밀번호가 일치하지 않음",
        },
        {
          shouldFocus: true,
        }
      );
    } else {
      try {
        await patchPassword(data, accessToken);
        reset();
        SaveAlert();
        closeModal();
      } catch (e) {
        alert(e);
      }
    }
  };

  const { t } = useTranslation();

  return (
    <Modal
      style={{
        overlay: {
          zIndex: 100,
          width: "100%",
          height: "100vh",
          backgroundColor: "rgba(100, 100, 100, 0.3)",
          transition: "opacity 0.5s ease",
          top: "0",
          position: "fixed",
        },
        content: {
          width: "500px",
          height: "fit-content",
          backgroundColor: "#ebecee",
          borderRadius: "15px",
          overflow: "hidden",
          position: "absolute",
          left: "50%",
          top: "45%",
          transform: `translate(-50%, -50%)`,
        },
      }}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
    >
      <ModalContainer>
        <Title>{t(`change password`)}</Title>
        <XBtn onClick={closeModal} />
        <FormContainer>
          <InputForm onSubmit={handleSubmit(onVaild)}>
            <InputLabel>
              {t(`new password`)}
              <ErrorMsg>{errors?.newPassword?.message}</ErrorMsg>
            </InputLabel>
            <Input
              {...register("newPassword", {
                required: `* ${t(`please enter`)}`,
              })}
              type="password"
            />
            <InputLabel>
              {t(`check new password`)}
              <ErrorMsg>{errors?.newPasswordConfirm?.message}</ErrorMsg>
            </InputLabel>
            <Input
              {...register("newPasswordConfirm", {
                required: `* ${t(`please enter`)}`,
              })}
              type="password"
            />
            <Btn>변경</Btn>
          </InputForm>
        </FormContainer>
      </ModalContainer>
    </Modal>
  );
}

const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  padding: 20px;
`;

const Title = styled.h1`
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 30px;
`;

const XBtn = styled.img.attrs({
  src: `${xBtn}`,
})`
  width: 25px;
  height: 25px;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
`;

const FormContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 90%;
  padding: 30px;
`;
const InputForm = styled.form`
  display: flex;
  flex-direction: column;
`;
const InputLabel = styled.label`
  margin-bottom: 10px;
  color: #6b6e6d;
  font-weight: 500;
`;
const Input = styled.input`
  margin-bottom: 15px;
  height: 35px;
  font-size: 1rem;
  border: none;
  border-bottom: 2px solid black;
  &:focus {
    outline: none;
    transition: none;
  }
`;

const Btn = styled.button`
  margin-top: 20px;
  height: 50px;
  width: 100%;
  background-color: #ebecee;
  border: 1px solid #d8d8d8;
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  &:hover {
    background-color: #bddbff;
  }
`;

const ErrorMsg = styled.span`
  height: 30px;
  color: red;
  padding-top: 3px;
  width: 100%;
`;
